import { Icon } from '@euler/components/Icomoon';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { dateFromValue } from '@euler/utils/datetime';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import { memo } from 'react';
import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native';

const secondsPerHour = 3600;

export const Timestamp = memo(
  ({
    startTime = new Date(),
    timestamp,
    value,
    style,
    label,
    labelStyle,
    iconSize = 12,
    iconColor = '#555',
  }: {
    startTime?: string | Date;
    timestamp?: string | Date;
    value?: number;
    style?: StyleProp<ViewStyle>;
    label?: string;
    labelStyle?: StyleProp<TextStyle>;
    iconSize?: number;
    iconColor?: string;
  }) => {
    const { rpx } = useResponsiveContext();

    let sec =
      value !== undefined
        ? Math.round(value)
        : differenceInSeconds(
            dateFromValue(startTime),
            dateFromValue(timestamp),
            {
              roundingMethod: 'round',
            },
          );
    let day = 0,
      hour = 0,
      min = 0;
    day = Math.floor(sec / (secondsPerHour * 24));
    sec -= day * (secondsPerHour * 24);
    hour = Math.floor(sec / secondsPerHour);
    sec -= hour * secondsPerHour;
    min = Math.floor(sec / 60);
    sec -= min * 60;

    const components = [];
    if (day) {
      components.push(`${day}天`);
      if (hour) {
        components.push(`${hour}小时`);
      }
    } else if (hour) {
      components.push(`${hour}小时`);
    } else if (min) {
      components.push(`${min}分`);
    } else {
      components.push(`${sec}秒`);
    }

    const text = `${label ?? '在厂'}${components.join('')}`;

    return (
      <View
        css={`
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
        `}
        style={style}
      >
        <Icon
          name="clock"
          size={iconSize}
          color={iconColor}
          css={`
            margin-top: 1px;
            margin-right: 2px;
          `}
        />
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Thin};
            font-size: ${rpx(10)}px;
          `}
          style={labelStyle}
        >
          {text}
        </Text>
      </View>
    );
  },
);
